module.exports = __webpack_public_path__ + "img/pe05.f9eee0fc.jpg";